import API_BASE_URL from '../config';
import { getToken } from './authService';

const getHeaders = () => {
    const token = getToken();
    const headers = { 'Content-Type': 'application/json' };
    if (token) headers['Authorization'] = `Bearer ${token}`;
    return headers;
};

export const getShopLocations = async () => {
    const res = await fetch(`${API_BASE_URL}/shop-locations`);
    if (!res.ok) throw new Error('Failed to fetch shop locations');
    return await res.json();
};

export const createShopLocation = async (data) => {
    const res = await fetch(`${API_BASE_URL}/shop-locations`, {
        method: 'POST',
        headers: getHeaders(),
        body: JSON.stringify(data)
    });
    if (!res.ok) throw new Error('Failed to create shop location');
    return await res.json();
};

export const updateShopLocation = async (id, data) => {
    const res = await fetch(`${API_BASE_URL}/shop-locations/${id}`, {
        method: 'PUT',
        headers: getHeaders(),
        body: JSON.stringify(data)
    });
    if (!res.ok) throw new Error('Failed to update shop location');
    return await res.json();
};

export const deleteShopLocation = async (id) => {
    const res = await fetch(`${API_BASE_URL}/shop-locations/${id}`, {
        method: 'DELETE',
        headers: getHeaders()
    });
    if (!res.ok) throw new Error('Failed to delete shop location');
    return await res.json();
};

export const reorderShopLocations = async (orderedShops) => {
    const res = await fetch(`${API_BASE_URL}/shop-locations/reorder`, {
        method: 'PUT',
        headers: getHeaders(),
        body: JSON.stringify({ orderedShops })
    });
    if (!res.ok) throw new Error('Failed to reorder shop locations');
    return await res.json();
};
